module.exports = "/_next/static/images/property@2x-63a184038e63f91240b224e7326ffa61.png";